import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'

import { Button, TextInputField } from "../../../helpers"
import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import { updateBuyerReqItemQty } from "../../../services/api/buyerReqItem"
import { getBuyerQuoteItemByBuyerQuoteIds } from "../../../services/api/buyerQuoteItem"
import { updateBuyerRequirementItemsData } from "../../../services/redux/reducers/Requirement/requirement"


const EditBuyerReqItemQty = (props) => {
    const { buyerReqDisplayProducts, selectedReq, setVisibleEditBuyerReqItemQty, buyerQuotes } = props

    const dispatch = useDispatch()

    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [qtyChanges, setQtyChanges] = useState({})
    const [updatedBuyerReqDisplayProducts, setUpdatedBuyerReqDisplayProducts] = useState([])

    const buyerRequirementItemsData = useSelector(state => state.requirements.buyerRequirementItemsData)

    useEffect(() => {
        if (buyerQuotes?.length && selectedReq) {
            getBuyerQuoteItems()
        }
    }, [buyerQuotes, selectedReq])

    useEffect(() => {
        const updatedBuyerReqDisplayProducts = buyerReqDisplayProducts.map(product => {
            const relatedQuoteItems = buyerQuoteItems.filter(quote => quote.buyerReqItemId === product.buyerReqItemId)

            const maxQuoteQty = relatedQuoteItems.length > 0
                ? Math.max(...relatedQuoteItems.map(quote => quote.totReqQty))
                : 0

            return { ...product, maxQuoteQty }
        })
        setUpdatedBuyerReqDisplayProducts(updatedBuyerReqDisplayProducts)

    }, [buyerQuoteItems])

    const getBuyerQuoteItems = async () => {
        const relatedBuyerQuotes = buyerQuotes.filter(eachBuyerQuote => eachBuyerQuote.buyerReqId === selectedReq.buyerReqId)
        const relatedBuyerQuoteIds = relatedBuyerQuotes.map(eachBuyerQuote => eachBuyerQuote.buyerQuoteId)

        const buyerQuoteItemsRes = await getBuyerQuoteItemByBuyerQuoteIds(relatedBuyerQuoteIds)
        if (!buyerQuoteItemsRes.failure) {
            setBuyerQuoteItems(buyerQuoteItemsRes.data)
        }
    }

    const handleInputQtyChange = (event, buyerReqItemId) => {
        let newQty = event.target.value

        setQtyChanges(prevState => ({
            ...prevState,
            [buyerReqItemId]: newQty
        }))
    }

    const handleUpdateQty = async () => {
        const changedItems = Object.entries(qtyChanges)
            .map(([buyerReqItemId, qty]) => ({ buyerReqItemId, qty }))
            .filter(item => item.qty !== '')

        const invalidQtyExists = changedItems.some(eachChangedItem => {
            const relatedBuyerReqItem = updatedBuyerReqDisplayProducts.find(eachReqItem => eachReqItem.buyerReqItemId === parseInt(eachChangedItem.buyerReqItemId))
            if (eachChangedItem.qty < relatedBuyerReqItem.maxQuoteQty) {
                return true 
            }
            return false
        })

        if (changedItems.length === 0) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'No Input found.' }))
        } 
        if (invalidQtyExists) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Input can only be reduced up to Quote Qty.' }))
        }

        if (window.confirm("Are you sure to update?")) {
            const response = await updateBuyerReqItemQty(changedItems)
            if (!response.failure) {
                const updatedBuyerRequirementItemsData = buyerRequirementItemsData.map(item => {
                    const relatedChangedItem = changedItems.find(eachItem => item.buyerReqItemId === parseInt(eachItem.buyerReqItemId))

                    return relatedChangedItem ? { ...item, qty: relatedChangedItem.qty } : item
                })

                dispatch(updateBuyerRequirementItemsData(updatedBuyerRequirementItemsData))
                setVisibleEditBuyerReqItemQty(false)

                return dispatch(raiseToast({ severity: 'success', detail: 'Qty updated successfully', life: 3000 }))
            }else{
                return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))

            }
        }
    }

    return (
        <div className='flex flex-column justify-content-between h-100'>
            <div className="p-card p-2">
                <div className="flex flex-wrap py-2 w-full">
                    <div className="flex pl-2 w-full header-style" style={{ color: "#6c757d" }}>
                        <div className="mb-2" style={{ width: '10%' }}>Material Id</div>
                        <div className="mb-2" style={{ width: '15%' }}>Category</div>
                        <div className="mb-2" style={{ width: '20%' }}>Product-Variant</div>
                        <div className="mb-2" style={{ width: '25%' }}>Specification</div>
                        <div className="mb-2" style={{ width: '10%' }}>Curr.Qty</div>
                        <div className="mb-2" style={{ width: '10%' }}>Quote Qty</div>
                        <div className="mb-2" style={{ width: '10%' }}>Edit Qty</div>
                    </div>
                    <div className="w-full">
                        {updatedBuyerReqDisplayProducts.map((eachProduct) => {
                            return (
                                <div className="flex pl-2 data-style" key={`buyerReqItem-${eachProduct.buyerReqItemId}`}>
                                    <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>{eachProduct.materialId}</div>
                                    <div className="py-2" style={{ width: '15%', alignSelf: "center" }}>{eachProduct.companyERPCategory}</div>
                                    <div className="py-2" style={{ width: '20%', alignSelf: "center" }}>
                                        {eachProduct.productName} - {eachProduct.variantName}
                                    </div>
                                    <div className="py-2" style={{ width: '25%', alignSelf: "center" }}>
                                        {eachProduct.productSpecification}
                                    </div>
                                    <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>
                                        {eachProduct.qty}
                                    </div>
                                    <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>
                                        {eachProduct.maxQuoteQty}
                                    </div>
                                    <div className="py-2" style={{ width: '10%', alignSelf: "center" }}>
                                        <TextInputField
                                            name={`inputQty-${eachProduct.buyerReqItemId}`}
                                            labelText=""
                                            style={{ width: "100%" }}
                                            value={qtyChanges[eachProduct.buyerReqItemId]}
                                            keyfilter="num"
                                            onChange={(e) => handleInputQtyChange(e, eachProduct.buyerReqItemId)}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className='flex justify-content-end'>
                <Button className="h-2rem p-2" label="UPDATE QTY" onClick={handleUpdateQty} />
            </div>
        </div>
    )
}

export default EditBuyerReqItemQty
